import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestReducer(state = initialState.budgetrequestContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETREQUESTCONTENT_SUCCESS:
      return action.budgetrequestContent;
    default:
      return state;
  }
}
